import React, { useState, useEffect } from 'react';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import AboutusBG from "../../../Assets/AboutUs_Img/about_background_img.webp";
import { Link } from "react-router-dom";
import euro_grey from "../../../Assets/Product_Page/euro_grey.webp";
import features_img from "../../../Assets/Product_Page/features_img.webp";
import applications from "../../../Assets/Product_Page/applications.webp";
import features_1 from "../../../Assets/Product_Page/features_1.webp";
import features_2 from "../../../Assets/Product_Page/features_2.webp";
import features_3 from "../../../Assets/Product_Page/features_3.webp";
import applications_1 from "../../../Assets/Product_Page/applications_1.webp";
import applications_2 from "../../../Assets/Product_Page/applications_2.webp";
import applications_3 from "../../../Assets/Product_Page/applications_3.webp";
import applications_4 from "../../../Assets/Product_Page/applications_4.webp";
import applications_5 from "../../../Assets/Product_Page/applications_5.webp";
import api from "../../../api/api";

const EuroGrey = () => {
  const [activeTab, setActiveTab] = useState('features');
  const [euroGreyData, setEuroGreyData] = useState([]);

  const featureImages = [features_1, features_2, features_3];
  const applicationImages = [
    applications_1,
    applications_2,
    applications_3,
    applications_4,
    applications_5
  ];

  useEffect(() => {
    api.get("/eurogrey") // Backend route
      .then((res) => {
        setEuroGreyData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching Euro Grey data", err);
      });
  }, []);

  const title = euroGreyData.length > 0 ? euroGreyData[0].title : 'EuroGrey';

  return (
    <div>
      <Header />

      {/* Banner section */}
      <section className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AboutusBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h1>
                  <Link to='/Product' className="text-decoration-none text-white">
                    PRODUCTS / {title}
                  </Link>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product section */}
      <section className="container-fluid clear_sction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="clear_text">
                <img src={euro_grey} alt="Euro Grey" />
                <h5>{title}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs section */}
      <section className="container-fluid features_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="tabs">
                <div className="tab-buttons">
                  <button
                    className={`tab-btn ${activeTab === 'features' ? 'active' : ''}`}
                    onClick={() => setActiveTab('features')}
                  >
                    <img src={features_img} alt="Features" /> Features
                  </button>
                  <button
                    className={`tab-btn ${activeTab === 'applications' ? 'active' : ''}`}
                    onClick={() => setActiveTab('applications')}
                  >
                    <img src={applications} alt="Applications" /> Applications
                  </button>
                </div>

                {/* Features */}
                {activeTab === 'features' && (
                  <div id="features" className="tab-content active">
                    <ul>
                      {euroGreyData.map((item) =>
                        (Array.isArray(item.features) ? item.features : JSON.parse(item.features || "[]"))
                          .map((feature, i) => (
                            <li key={i}>
                              <img
                                src={featureImages[i % featureImages.length]}
                                alt={`Feature ${i + 1}`}
                              />
                              {feature}
                            </li>
                          ))
                      )}
                    </ul>
                  </div>
                )}

                {/* Applications */}
                {activeTab === 'applications' && (
                  <div id="applications" className="tab-content active">
                    <ul>
                      {euroGreyData.map((item) =>
                        (Array.isArray(item.applications) ? item.applications : JSON.parse(item.applications || "[]"))
                          .map((application, i) => (
                            <li key={i}>
                              <img
                                src={applicationImages[i % applicationImages.length]}
                                alt={`Application ${i + 1}`}
                              />
                              {application}
                            </li>
                          ))
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EuroGrey;
